module.exports = __webpack_public_path__ + "img/26_211.04f82402.png";